<template>
  <div class="container">
    <div class="content">
      <div class="top">
        <div class="header">
          <img alt="logo" class="logo" src="static/img/vue-antd-logo.png" />
          <span class="title">{{systemName}}</span>
        </div>
      </div>
      <div class="login">
        <el-form ref="loginForm"
                 :model="loginForm"
                 :rules="loginRules"
                 class="login-form"
                 auto-complete="on"
                 label-position="left">
          <el-form-item prop="loginName">
            <el-input
              ref="loginName"
              v-model="loginForm.loginName"
              placeholder="Username"
              name="username"
              type="text"
              tabindex="1">
              <i slot="prefix" class="el-icon-user-solid"></i>
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              :type="passwordType"
              placeholder="Password"
              name="password"
              tabindex="2"
              @keyup.enter.native="handleLogin">
              <i slot="prefix" class="el-icon-key"></i>
              <span slot="suffix" @click="showPwd" style="margin-right: 15px">
                 <i :class= "passwordType === 'password' ? 'el-icon-s-cooperation' : 'el-icon-view'"></i>
              </span>
            </el-input>
            <div>
              <el-checkbox v-model="loginForm.rememberPassword">记住密码</el-checkbox>
              <a style="float: right" @click="updatePasswordDialogVisible = true">修改密码</a>
            </div>
          </el-form-item>
          <el-button :loading="loading" type="primary"
                     style="width:100%;margin-bottom:30px;"
                     @click.native.prevent="handleLogin">
            登录
          </el-button>
        </el-form>
        <el-dialog
          title="修改密码"
          :visible.sync="updatePasswordDialogVisible"
          @opened="onEditOpen"
          width="30%">
          <el-form ref="updatePasswordForm"
                   :model="updatePasswordForm"
                   :rules="updatePasswordFormRules"
                   class="login-form"
                   label-position="left"
                   label-width="80px">
            <el-form-item label="用户名字" prop="loginName">
              <el-input
                ref="updatePasswordForm"
                v-model="updatePasswordForm.loginName"
                placeholder="Username"
                name="username"
                type="text">
                <i slot="prefix" class="el-icon-user-solid"></i>
              </el-input>
            </el-form-item>

            <el-form-item label="旧密码" prop="password">
              <el-input
                ref="updatePasswordForm"
                v-model="updatePasswordForm.password"
                type="password"
                placeholder="旧密码"
                name="password">
                <i slot="prefix" class="el-icon-key"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                ref="updatePasswordForm"
                v-model="updatePasswordForm.newPassword"
                type="password"
                placeholder="新密码"
                @blur="blurText"
                name="password">
                <i slot="prefix" class="el-icon-key"></i>
              </el-input>
              <span style="color: red" v-if="warnMsg" v-html="warnMsg"></span>
            </el-form-item>

            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                ref="updatePasswordForm"
                v-model="updatePasswordForm.confirmPassword"
                type="password"
                placeholder="确认密码"
                name="password">
                <i slot="prefix" class="el-icon-key"></i>
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="updatePasswordDialogVisible = false" size="medium">取 消</el-button>
            <el-button :loading="updatePasswordLoading" type="primary" @click="updatePassword()" size="medium">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <global-footer :link-list="linkList" :copyright="copyright" />
  </div>
</template>
<script>
import GlobalFooter from '../../layouts/GlobalFooter'
import { updatePassword } from '@/api/login'
import RsaEncrypt from '@/utils/RsaEncrypt'
import store from '../../store'
import router from '../../router/lazy'
export default {
  name: 'Login',
  components: {GlobalFooter},
  data () {
    return {
      updatePasswordLoading: false,
      updatePasswordDialogVisible: false,
      updatePasswordForm: {
        loginName: '',
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      loginForm: {
        loginName: '',
        password: '',
        rememberPassword: false
      },
      loginRules: {
        loginName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      updatePasswordFormRules: {
        loginName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '确认密码', trigger: 'blur' }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      warnMsg: ''
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    linkList () {
      return this.$store.state.setting.footerLinks
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  // watch: {
  //   $route: {
  //     handler: function (route) {
  //       this.redirect = route.query && route.query.redirect
  //     },
  //     immediate: true
  //   }
  // },
  created () {
    this.loginForm.loginName = sessionStorage.getItem('loginName')
    this.loginForm.password = sessionStorage.getItem('passwordToken')
    this.$store.dispatch('initClickMenu')
    if (this.$store.state.user.systemAuths.find((item) => item.path === '/') &&
      this.$store.state.user.systemAuths.find((item) => item.path === '/').children.length > 1) {
      location.reload()
    }
  },
  methods: {
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    // 登录
    handleLogin () {
      let passwordToken = sessionStorage.getItem('passwordToken')
      if (passwordToken) {
        // this.loading = true
        // Token登录
        store.dispatch('LoginByPasswordToken', passwordToken).then(() => {
          this.loading = false
          let historyPath = sessionStorage.getItem('historyPath')
          if (historyPath) {
            router.push({ path: historyPath })
          } else {
            router.push({ path: '/dashboard/workplace' })
          }
        }).catch(err => {
          if (err.data.businessErrorKey === 'firstLogin' || err.data.businessErrorKey === 'passwordIsTooSimple') {
            this.updatePasswordDialogVisible = true
          }
          this.loading = false
          console.log('loginByToken error!!')
        })
      } else {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            // this.loading = true
            // 登录
            this.$store.dispatch('LoginByUsername', this.loginForm).then(res => {
              let historyPath = sessionStorage.getItem('historyPath')
              if (historyPath) {
                router.push({ path: historyPath })
              } else {
                router.push({ path: '/dashboard/workplace' })
              }
              this.loading = false
            }).catch((err) => {
              if (err.data.businessErrorKey === 'firstLogin' || err.data.businessErrorKey === 'passwordIsTooSimple') {
                this.updatePasswordDialogVisible = true
              }
              this.loading = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    updatePassword () {
      this.$refs.updatePasswordForm.validate(valid => {
        if (valid) {
          this.updatePasswordLoading = true
          var updateParams = {
            loginName: this.updatePasswordForm.loginName,
            password: this.updatePasswordForm.password,
            newPassword: this.updatePasswordForm.newPassword,
            confirmPassword: this.updatePasswordForm.confirmPassword
          }
          RsaEncrypt(this.updatePasswordForm.password, (res) => {
            updateParams.password = res
            RsaEncrypt(this.updatePasswordForm.newPassword, (res) => {
              updateParams.newPassword = res
              RsaEncrypt(this.updatePasswordForm.confirmPassword, (res) => {
                updateParams.confirmPassword = res
                updatePassword(updateParams).then(res => {
                  this.updatePasswordLoading = false
                  this.updatePasswordDialogVisible = false
                  return this.$notify({
                    title: '成功',
                    message: '修改成功',
                    type: 'success'
                  })
                }).catch(() => {
                  this.updatePasswordLoading = false
                })
              })
            })
          })
        } else {
          console.log('error submit!!')
          this.updatePasswordLoading = false
          return false
        }
      })
    },
    blurText () {
      // 用户名正则，4到16位（字母，数字，下划线，减号）
      let regExp = /^(?![^a-zA-Z]+$)(?!\D+$)/
      // 输出 true
      this.warnMsg = ''
      let boolean = true
      if (this.updatePasswordForm.newPassword.length < 6 || this.updatePasswordForm.newPassword.length > 16) {
        boolean = false
      }
      if (boolean) {
        boolean = regExp.test(this.updatePasswordForm.newPassword)
      }
      if (!boolean) {
        this.$message.error('密码包含组成数字,字母, 长度为6-16!')
        this.updatePasswordForm.newPassword = ''
        this.warnMsg = '密码包含组成数字,字母, 长度为6-16!'
      }
    },
    onEditOpen () {
      this.updatePasswordForm.loginName = this.loginForm.loginName
    }
  }
}
</script>
<style lang="less" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: auto;
    align-items: center;
    background: #f0f2f5 url('https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg') no-repeat center 110px;
    background-size: 100%;
    .content {
      padding: 32px 0;
      flex: 1;
      @media (min-width: 768px){
        padding: 160px 0 24px;
      }
      .top {
        margin-bottom: 25px;
        text-align: center;
        .header {
          height: 44px;
          line-height: 44px;
          a {
            text-decoration: none;
          }
          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
          }
          .title {
            font-size: 33px;
            color: rgba(0,0,0,.85);
            font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
            letter-spacing: 3px;
          }
        }
      }
      .login{
        .login-form {
          position: relative;
          width: 520px;
          max-width: 100%;
          margin: 0 auto;
          overflow: hidden;
        .el-input {
          display: inline-block;
          height: 47px;
          width: 100%;
          input {
            background: transparent;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            padding: 12px 5px 12px 15px;
            color: #fff;
            height: 50px;
            caret-color: #fff;
          }
        }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue